<script>
import WorkflowCard from "@/components/workflow-management/WorkflowCard.vue";

export default {
  components: { WorkflowCard },
  props: {
    workflow: Object
  },
}
</script>

<template>
  <workflow-card :hex-id="workflow.hexId" />
</template>

<style scoped>

</style>
